module.exports = __webpack_public_path__ + "static/img/074.e80afd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/074.png
// module id = MaIE
// module chunks = 0